<style lang="scss" scoped>
.quote-marker {
    &:before {
        content: "“";
        font-size: 140px;
        @apply absolute top-24 left-0 font-bold text-green;
    }
}

.tab {
    cursor: pointer;

    &:after {
        content: "";
        @apply absolute bottom-0 h-2 w-full bg-transparent transition-all;
    }

    &:hover {
        &:after {
            @apply bg-green opacity-25;
        }
    }

    &.active {
        cursor: default;

        &:after {
            @apply bg-green opacity-100;
        }
    }
}

.component-fade-enter-active,
.component-fade-leave-active {
    transition: opacity 0.2s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>

<template>
    <div class="bg-light md:pt-80 pt-40">
        <div class="container">
            <transition name="component-fade" mode="out-in">
                <div class="lg:flex-row flex flex-col items-center justify-between" :key="activeIndex" v-if="activeQuote">
                    <div class="lg:w-4/12 md:w-6/12 lg:order-1 order-2 w-full">
                        <div class="pt-full relative w-full">
                            <img class="absolute inset-0 object-cover object-center w-full h-full rounded-sm" :src="activeQuote.image.sizes.medium_large" :alt="activeQuote.title" />
                        </div>
                    </div>
                    <div class="lg:w-6/12 md:w-10/12 lg:order-2 order-1 w-full py-40">
                        <div class="quote-marker relative">
                            <h2 class="md:text-h2 text-h4 font-mon z-20 mb-24 font-bold transform translate-x-16" v-html="activeQuote.title"></h2>
                            <div class="text-small text-dark z-20 transform translate-x-16" v-html="activeQuote.content"></div>
                        </div>
                    </div>
                </div>
            </transition>
            <div class="flex items-end justify-center">
                <div class="mt-116 md:w-1/3 tab md:block relative hidden w-full pb-32" :class="{ active: activeIndex === index }" v-for="(quote, index) in quotes" :key="`tab_${index}`" @click="changeQuote(index)">
                    <div class="flex items-center justify-center">
                        <img v-if="quote.profile_picture && quote.profile_picture.sizes" class="inline-block object-cover object-center w-32 h-32 mr-16 rounded-full" :src="quote.profile_picture.sizes.thumbnail" :alt="quote.name" />
                        <div class="flex flex-col">
                            <span class="font-mon text-small mb-1 font-bold" v-html="quote.name"></span>
                            <span class="text-tiny text-gray font-sans" v-html="quote.function"></span>
                        </div>
                    </div>
                </div>
                <div class="pb-60 md:hidden flex items-center w-full mt-40" v-if="activeQuote">
                    <svg @click="previousQuote" v-if="quotes && quotes.length > 1" width="16" height="16" class="mr-auto" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <use :xlink:href="`/svg/feather-sprite.svg#chevron-left`" />
                    </svg>
                    <transition name="component-fade" mode="out-in">
                        <div class="flex items-center justify-center" :key="activeIndex">
                            <img v-if="activeQuote.profile_picture && activeQuote.profile_picture.sizes" class="inline-block object-cover object-center w-32 h-32 mr-16 rounded-full" :src="activeQuote.profile_picture.sizes.thumbnail" :alt="activeQuote.name" />
                            <div class="flex flex-col">
                                <span class="font-mon text-small mb-1 font-bold" v-html="activeQuote.name"></span>
                                <span class="text-tiny text-gray font-sans" v-html="activeQuote.function"></span>
                            </div>
                        </div>
                    </transition>
                    <svg @click="nextQuote" v-if="quotes && quotes.length > 1" width="16" height="16" class="ml-auto" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <use :xlink:href="`/svg/feather-sprite.svg#chevron-right`" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => {
        return {
            activeIndex: 0,
            activeQuote: null
        };
    },

    props: {
        quotes: {
            type: Array,
            required: true
        }
    },

    mounted() {
        if (this.quotes && this.quotes.length) {
            this.changeQuote(0);
        }
    },

    methods: {
        changeQuote(index) {
            this.activeIndex = index;
            this.activeQuote = this.quotes[index];
        },

        previousQuote() {
            if (this.activeIndex === 0) {
                this.changeQuote(this.quotes.length - 1);
            } else {
                this.changeQuote(this.activeIndex - 1);
            }
        },

        nextQuote() {
            if (this.activeIndex === this.quotes.length - 1) {
                this.changeQuote(0);
            } else {
                this.changeQuote(this.activeIndex + 1);
            }
        },
    }
};
</script>
